import { Box, BoxProps, CheckBox, Spacer, Text, TextNew } from '@jfs/ui-new'
import React, { useEffect } from 'react'
import { FlatList } from 'react-native-gesture-handler'

export const PaymentModes = ({ fieldName, setFieldValue, value, label }) => {
  const [checkBoxData, updateCheckBoxData] = React.useState(JSON.parse(JSON.stringify(value)))

  useEffect(() => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, checkBoxData)
    }
  }, [checkBoxData])
  const evaluateAllChecked = () => {
    if (
      checkBoxData?.filter((item: any) => {
        return item?.isChecked
      }).length === 0
    ) {
      return 'false'
    } else if (
      checkBoxData?.filter((item: any) => {
        return item?.isChecked
      }).length === checkBoxData?.length
    ) {
      return 'true'
    }
  }

  const isAllChecked = () => {
    return (
      checkBoxData?.filter((item: any) => {
        return !item?.isChecked
      }).length === 0
    )
  }
  const toggleAll = () => {
    const isChecked = isAllChecked()
    const updatedCheckBoxData = checkBoxData?.map((data: any) => {
      data.isChecked = !isChecked
      return data
    })
    updateCheckBoxData(updatedCheckBoxData)
  }

  const _renderItem = (item: any) => {
    return (
      <Box {...styles.itemContainer}>
        <CheckBox
          checked={item.item?.isChecked ?? false}
          onChange={() => {
            const updatedCheckBoxData = checkBoxData?.map((data: any) => {
              if (data?.mode === item?.item?.mode) {
                data.isChecked = !data?.isChecked
              }
              return data
            })
            updateCheckBoxData(updatedCheckBoxData)
            evaluateAllChecked()
          }}
          iconSize={16}
          color={item.item?.isChecked ? 'BLUE_SHADE_PRIMARY' : 'PRIMARY_GREY'}
        />
        <Spacer direction="horizontal" size={8} />
        <TextNew fontSize={12} color="PRIMARY_GREY" fontFamily="JioType-Medium">
          {item.item?.mode}
        </TextNew>
      </Box>
    )
  }

  return (
    <Box flexDirection={'row'}>
      <Box pv={16} w={150}>
        <Text title={label} fontFamily={'jiotype-medium'} fontSize={14} color={'BLACK_21'} />
      </Box>
      <Spacer direction="horizontal" size={64} />
      <Box {...styles.parent}>
        <CheckBox
          textLabel={'All'}
          onChecked={toggleAll}
          iconSize={16}
          value={evaluateAllChecked()}
          fontSize={14}
          color={isAllChecked() ? 'BLUE_SHADE_PRIMARY' : 'PRIMARY_GREY'}
        />
      </Box>
      <Box>
        <FlatList data={checkBoxData} renderItem={_renderItem} keyExtractor={(item: any) => item?.mode} />
      </Box>
    </Box>
  )
}

const styles = {
  parent: {
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
  itemContainer: {
    paddingLeft: 24,
    height: 48,
    flexDirection: 'row',
    alignItems: 'center',
  } as BoxProps,
}

enum IconStates {
  CHECKBOX_OUTLINE = 'CHECKBOX_OUTLINE',
  CHECKBOX_UNCHECKED = 'CHECKBOX_UNCHECKED',
  CHECKBOX_CHECKED = 'CHECKBOX_CHECKED',
}
